import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import makeStyles from '@mui/styles/makeStyles';
import { useMatches } from 'react-router-dom';

import NRMenuItem from '../../../components/NRMenuItem/NRMenuItem';
import NRSideNavbarStyles from './NRSideNavbar.styles';
import NRDashboardLight from '../../../NRIcons/NRDashboardLight/NRDashboardLight';
import NRSearchIcon from '../../../NRIcons/NRSearchIcon';
import NetRisePlainLogo from '../../../NRIcons/NetRisePlainLogo';
import NRSettingsIcon from '../../../NRIcons/NRSettingsIcon';
import NRAssetIcon from '../../../NRIcons/NRAssetIcon';
import NRGroupIcon from '../../../NRIcons/NRGroupIcon';

import { CONSTANTS } from '../../../constants/constants';
const { ASSETS, GROUPS, SEARCH, OVERVIEW } = CONSTANTS.SIDE_NAVBAR.MENU_ITEMS;

const useStyles = makeStyles(NRSideNavbarStyles);

function NRSideNavbar() {
  const classes = useStyles();
  const matches = useMatches();

  // Find the deepest matched route that has a `handle.menu`
  const currentMenu = [...matches].reverse().find(match => match.handle?.menu)?.handle?.menu;

  return (
    <Drawer
      variant="permanent"
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div>
        <div className={classes.logo}>
          <NetRisePlainLogo />
        </div>
        <List>
          <NRMenuItem route={'/'} text={OVERVIEW} icon={<NRDashboardLight />} selected={currentMenu} />
          <NRMenuItem route={'/assets'} text={ASSETS} icon={<NRAssetIcon />} selected={currentMenu} />
          <NRMenuItem route={'/groups'} text={GROUPS} icon={<NRGroupIcon />} selected={currentMenu} />
          <NRMenuItem route={'/search'} text={SEARCH} icon={<NRSearchIcon />} selected={currentMenu} />
          <NRMenuItem route={'/settings'} text={'Settings'} icon={<NRSettingsIcon />} selected={currentMenu} />
        </List>
      </div>
    </Drawer>
  );
}

export default NRSideNavbar;
